import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './InvoicesTable.styles';
import { Invoice } from '@/features/Profile/sections/Invoices/Invoices.types';
import { InvoiceRow } from '@/features/Profile/sections/Invoices/components/InvoiceRow';

interface InvoicesTableProps {
  invoices: Invoice[];
  onShowDetails: (invoice: Invoice) => void;
  loadMoreSkeleton?: React.ReactNode;
}

export function InvoicesTable({
  invoices,
  onShowDetails,
  loadMoreSkeleton,
}: InvoicesTableProps) {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Header>
        <S.HeaderCell>{t('pages.cabinet.creation_date')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.invoice_number_short')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.service')}</S.HeaderCell>
        <S.HeaderCell>{t('common.sum')}</S.HeaderCell>
        <S.StatusHeaderCell>
          {t('pages.cabinet.status_and_date')}
        </S.StatusHeaderCell>
        <S.HeaderCell />
        <S.HeaderCell />
      </S.Header>

      {invoices.map(invoice => (
        <InvoiceRow
          key={invoice.id}
          invoice={invoice}
          onShowDetails={onShowDetails}
        />
      ))}

      {loadMoreSkeleton}
    </S.Container>
  );
}
